module.exports = __webpack_public_path__ + "static/gallery-img-15-0557726c465003adc21c2f8d67d52975.jpg";